import { defineMessage } from 'services/localization';

export const messages = {
    step1: defineMessage('download_the_app'),
    step2: defineMessage('enter_the_code'),
    step3: defineMessage('backup_method'),
};
